import { TextValidator } from "anketa-core/validation";
import {
  convertSeconds,
  generateJWTToken,
  generateSimpleToken,
  timeToSeconds,
} from ".";
import { Translation } from "anketa-core/i18n";
import { OpenQuestion } from "anketa-core/open_question";
import { AnketaCheckPermissionOptions, AnketaResourcesEnum } from "../../../..";
import { QuestionsRightsTypes } from "..";
import { Section } from "anketa-core/group";

export const defaultJwtExpiresIn: number = timeToSeconds.weeks(157);

export const vaultSettings = (
  questionsRights: (
    q: QuestionsRightsTypes,
    options?: AnketaCheckPermissionOptions<AnketaResourcesEnum.questionnaires>,
  ) => void,
) => {
  const vaultGroup = new Section("vault", [
    new Translation("en", "APIs"),
    new Translation("de", "APIs"),
  ]);
  questionsRights(vaultGroup, {
    isInternal: true,
    isExternal: false,
    hideForExternal: true,
  });

  return vaultGroup;
};
export const opsanioMostToken = (
  questionerId: string,
  oldValues: any,
  questionsRights: (
    q: QuestionsRightsTypes,
    options?: AnketaCheckPermissionOptions<AnketaResourcesEnum.questionnaires>,
  ) => void,
  authToken: string,
): OpenQuestion => {
  const mostToken = new OpenQuestion("most_token", [
    new Translation("en", "Most Token"),
    new Translation("de", "Most Token"),
  ]);

  mostToken.description = [
    new Translation(
      "en",
      `With this JWT token, the must can get the individual environment variables for deployment. Token expires in ${convertSeconds(
        defaultJwtExpiresIn,
      )}.`,
    ),
    new Translation(
      "de",
      `Mit diesem JWT-Token können die einzelnen Umgebungsvariablen für den Einsatz abgerufen werden. Token läuft in ${convertSeconds(
        defaultJwtExpiresIn,
      )} ab.`,
    ),
  ];

  questionsRights(mostToken, {
    isInternal: true,
    isExternal: false,
    hideForExternal: true,
  });

  mostToken.validator = new TextValidator();

  const vpc = oldValues ? oldValues["networks.vpc.vpc_name"]?.value : "";
  const oldMostToken =
    oldValues && oldValues["most_token"] !== undefined
      ? oldValues["most_token"].value
      : "";
  const [catalog, pp] = window.location.pathname.split("/").slice(2);
  /*   console.log("Debug", {
    oldMostToken,
    questionerId,
    catalog,
    defaultJwtExpiresIn,
    authToken,
    crypto,
  }); */
  if (
    oldMostToken === null ||
    oldMostToken === undefined ||
    (typeof oldMostToken === "string" && oldMostToken.trim() === "")
  ) {
    try {
      if (typeof crypto !== "undefined" && crypto.subtle) {
        generateJWTToken(questionerId, catalog, defaultJwtExpiresIn, authToken)
          .then((token) => {
            console.log("Debug", "CREATE NEW TOKEN ", token);
            mostToken.setFactValue(token);
          })
          .catch((error) => {
            generateSimpleToken(
              questionerId,
              catalog,
              defaultJwtExpiresIn,
              vpc,
              authToken,
            ).then((token) => {
              mostToken.setFactValue(token);
            });
          });
      } else {
        generateSimpleToken(
          questionerId,
          catalog,
          defaultJwtExpiresIn,
          vpc,
          authToken,
        ).then((token) => {
          mostToken.setFactValue(token);
        });
      }
    } catch (error) {
      mostToken.setFactValue(null);
    }
  } else {
    mostToken.setFactValue(oldMostToken);
  }

  return mostToken;
};
